import { getGatewaysWithMachines as fetchGatewaysWithMachines } from "@src/cloud-connect/api/client-configuration/get-gateways-with-machines";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { RawGatewaysWithMachinesResponse } from "../entities/transform-gateways-with-machines-response";

interface LoadGatewaysWithMachinesDataResult {
  success: boolean;
  data?: RawGatewaysWithMachinesResponse;
  error?: string;
}

export const loadGatewaysWithMachinesData =
  async (): Promise<LoadGatewaysWithMachinesDataResult> => {
    try {
      const namespace =
        store.getState().yourSlice.authContext?.customerNamespace;
      if (!namespace) {
        return {
          error: "Customer namespace is unavailable.",
          success: false,
        };
      }

      const response = await fetchGatewaysWithMachines(namespace);

      if (!response) {
        return {
          error: "Empty response while loading gateways with machines.",
          success: false,
        };
      }

      return {
        data: response,
        success: true,
      };
    } catch (error) {
      return {
        error: parseAxiosApiError(
          error,
          "Failed to load gateways with machines.",
        ).message,
        success: false,
      };
    }
  };
